import { testimonials } from '@/mocks/homeData';

const principles = [
  { icon: 'ri-time-line', title: '盯节奏', desc: '把娱乐话题的爆发时点整理成可预期的蹲瓜时间表。' },
  { icon: 'ri-scales-3-line', title: '重盘点', desc: '用热度曲线与数据说话，复盘谁在持续发力、谁在降温。' },
  { icon: 'ri-emotion-happy-line', title: '不剧透', desc: '保住你亲自蹲守和参与讨论的乐趣，把悬念留给你。' },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="text-sm font-semibold tracking-widest text-primary-600">关于我们</span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              大瓜预警，<span className="text-primary-600">是什么</span>
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700 md:text-lg">
              大瓜预警是一个专注于整理娱乐话题节奏的资讯站。我们不追求复述每一个热搜，而是帮你把这些热点
              放进"周一见、周五晚、周末大瓜、月末盘点、季度压轴"的时间坐标里，
              让追热点这件事变得有章法、可预期。
            </p>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              无论你是追综多年的老瓜民，还是刚入坑的新朋友，都可以照着这张时间表安排自己的蹲守计划，
              重要节点的第一落点与反转续集都不错过。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${p.icon} text-xl`} />
                  </span>
                  <div className="mt-3 font-heading font-bold text-foreground-950">{p.title}</div>
                  <div className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</div>
                </div>
              ))}
            </div>

            {/* contact */}
            <div className="mt-6 flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-mail-send-line text-xl" />
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-900">联系我们</div>
                  <a href="mailto:hello@daguayujing.example" className="text-sm text-foreground-600 hover:text-primary-600">
                    hello@daguayujing.example
                  </a>
                </div>
              </div>
              <span className="text-sm text-foreground-500">蹲点投稿、栏目建议都欢迎聊聊</span>
            </div>
          </div>

          {/* testimonials 口碑 */}
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold tracking-widest text-accent-600">用户口碑</span>
            <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              吃瓜群众怎么说
            </h3>
            {testimonials.map((t, i) => (
              <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <i key={s} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-4 text-base leading-relaxed text-foreground-700 md:text-lg">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-background-50 ${i % 2 ? 'bg-secondary-500' : 'bg-primary-500'}`}>
                    {t.name[0]}
                  </span>
                  <span>
                    <span className="block font-medium text-foreground-900">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}

            <div className="rounded-2xl bg-foreground-950 p-6 text-background-50">
              <div className="flex items-center gap-3">
                <span className="font-latin text-4xl text-accent-400">96%</span>
                <p className="text-sm leading-relaxed text-background-100/80">
                  读者表示"照表蹲守"后明显少漏重要节点
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}